<template>
  <div class="vue-box">

    <!-- <Footer/> -->
    <router-view/>
  </div>
</template>

<script>
// import Footer from './components/common/Footer'
export default {
  // components:{
  //   Footer
  // },
  data(){
    return{
      configInfo:JSON.parse(localStorage.getItem("configInfo")),
    }
  },
  created(){
    if(this.configInfo){
      document.title = this.configInfo.app_name
    }else{
      document.title = ' '
    }
  },
  methods:{

  },

}
</script>
<style>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
*{-webkit-appearance: none;}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue